import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datepicker";
import ReactTooltip from "react-tooltip";

export default class Filter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: "",
            values: []
        };
        this.timer = "";
    }

    handleFilter = (value) => {
        this.setState({
            value
        });

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.props.handleFilter(this.props.filterName, value);
        }, 200);
    };

    clearAllFilters = () => {
        this.setState({
            value: "",
            values: []
        });

        if (["multiselect", "checkbox"].includes(this.props.type)) {
            this.props.handleFilter(this.props.filterName, []);
        } else {
            this.props.handleFilter(this.props.filterName, "");
        }
    };

    handleMultiFilter = (value) => {
        let values = this.state.values;

        if (values.includes(value)) {
            values = values.filter((item) => item !== value);
        } else {
            values.push(value);
        }
        this.setState({
            values
        });

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.props.handleFilter(this.props.filterName, values);
        }, 200);
    };

    handleFilters = (values) => {
        this.setState({
            values
        });

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.props.handleFilter(
                this.props.filterName,
                values.map((filter) => {
                    return filter.value;
                })
            );
        }, 200);
    };

    handleDateFilter = (momentVal) => {
        let value = "";
        if (momentVal != null && momentVal._isAMomentObject) {
            value = momentVal.format("YYYY-MM-DD");
        }
        this.setState({
            value
        });

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.props.handleFilter(this.props.filterName, value);
        }, 200);
    };

    componentDidMount() {
        if (this.props.activeFilters[this.props.filterName]) {
            this.setState({
                value: this.props.activeFilters[this.props.filterName],
                values: this.props.activeFilters[this.props.filterName]
            });
        }
    }

    componentDidUpdate(prevProps) {
        // clearing of the filters when it is passed along and is empty/undefined (global reset of filters)
        if (!this.props.activeFilters[this.props.filterName] && prevProps.activeFilters[this.props.filterName] && this.props?.compatibility === "new") {
            // only do this for the "dropdown" and when compatibility is set to 'new' to limit side-effects in old implementations
            this.clearAllFilters();
        }
    }

    render() {
        const filterContent = [];

        if (this.props.type !== "text") {
            const tooltipId = `filter-tooltip-${this.props.filterName}`;
            filterContent.push(
                <div className="filter-title" key={"filter-" + this.props.title}>
                    {!!this.props.noTitle === false && <h2>{this.props.title}</h2>}
                    {this.props.tooltip && (
                        <div className="filter-tooltip">
                            <i className="fa fa-info-circle" data-tip data-for={tooltipId} />
                            <ReactTooltip id={tooltipId} effect="solid" place="right">
                                {this.props.tooltip}
                            </ReactTooltip>
                        </div>
                    )}
                </div>
            );
        }

        // Dropdown filter
        if (this.props.type === "dropdown") {
            filterContent.push(
                <Select
                    className={this.props.className || ""}
                    {...window.selectDefaults}
                    placeholder={this.props.placeholder}
                    key={`dropdown-${this.props.title}`}
                    name={this.props.title}
                    value={this.state.value}
                    options={this.props.filters.map((filter) => {
                        return {
                            value: filter.value,
                            label: filter.name
                        };
                    })}
                    onChange={(value) => {
                        let val = value != null ? value.value : null;
                        this.handleFilter(val);
                    }}
                    multi={false}
                    closeOnSelect={true}
                />
            );
        }
        // Multi select items
        else if (this.props.type === "multiselect") {
            filterContent.push(
                <Select
                    {...window.selectDefaults}
                    key={`multiselect-${this.props.title}`}
                    name={this.props.title}
                    value={this.state.values}
                    options={this.props.filters.map((filter) => {
                        return {
                            value: filter.value,
                            label: filter.name
                        };
                    })}
                    className="full-width-labels"
                    onChange={(values) => this.handleFilters(values)}
                    multi={true}
                />
            );
        }
        // Text search
        else if (this.props.type === "text") {
            let currentFilter = "";
            if (this.props.filterName in this.props.activeFilters && this.props.activeFilters[this.props.filterName]) {
                currentFilter = this.props.activeFilters[this.props.filterName];
            }

            filterContent.push(
                <input
                    type="text"
                    className="filter-text"
                    key={"text-" + this.props.title}
                    onChange={(e) => this.handleFilter(e.target.value)}
                    placeholder={this.props.title}
                    value={this.state.value}
                />
            );
        }
        // Date filter
        else if (this.props.type === "date") {
            let currentValue = this.state.value !== "" ? moment(this.state.value) : null;

            filterContent.push(
                <React.Fragment key={"date-" + this.props.title}>
                    <DatePicker
                        onChange={this.handleDateFilter}
                        onChangeRaw={(event) => {
                            let value = event.target.value.split("-").join("");
                            let newDate = value.substring(0, 2);
                            if (value.length >= 3) {
                                newDate += "-" + value.substring(2, 4);
                            }
                            if (value.length >= 5) {
                                newDate += "-" + value.substring(4, 8);
                            }
                            event.target.value = newDate;
                        }}
                        className="form-control"
                        placeholder="Kies een datum (dd-mm-yyyy)"
                        selected={currentValue}
                        autoComplete="off"
                    />
                    {currentValue !== null && (
                        <span
                            className={"filter-reset-button"}
                            onClick={(e) => {
                                e.target.value = "";
                                this.handleDateFilter();
                                e.preventDefault();
                            }}
                        >
                            Reset filter
                        </span>
                    )}
                </React.Fragment>
            );
        } else if (this.props.type === "checkbox") {
            this.props.filters.forEach((filter) => {
                let currentFilter = this.props.filterName in this.props.activeFilters && this.props.activeFilters[this.props.filterName].includes(filter.value);
                let filterClass = classNames("filter-item-checkbox", { active: currentFilter });

                filterContent.push(
                    <label className={filterClass} key={filter.name + "-" + filter.value}>
                        <input type="checkbox" name={filter.name} value={filter.value} onChange={() => this.handleMultiFilter(filter.value)} checked={currentFilter} />
                        {filter.name}
                    </label>
                );
            });

            if (this.props.clearAll) {
                let filterClass = classNames("filter-item-checkbox", { active: this.state.values.length === 0 });
                filterContent.push(
                    <label className={filterClass} key={this.props.title + "-clearall"} onClick={() => this.clearAllFilters()}>
                        Toon alles
                    </label>
                );
            }
        }
        // List of options to filter on
        else {
            this.props.filters.forEach((filter) => {
                let currentFilter = this.props.filterName in this.props.activeFilters && this.props.activeFilters[this.props.filterName] === filter.value;

                if (this.props.activeFilters[this.props.filterName] == undefined && filter.value == "") {
                    currentFilter = true;
                }

                let filterClass = classNames("filter-item", { active: currentFilter });

                filterContent.push(
                    <button
                        className={filterClass}
                        key={filter.name + "-" + filter.value}
                        onClick={() => (currentFilter ? this.clearAllFilters() : this.handleFilter(filter.value))}
                    >
                        {filter.name}
                    </button>
                );
            });
        }

        return <div className="filter-block">{filterContent}</div>;
    }
}

Filter.defaultProps = {
    title: "Filter zonder titel",
    type: "list",
    noTitle: false
};

Filter.propTypes = {
    title: PropTypes.string.isRequired,
    noTitle: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    activeFilters: PropTypes.object.isRequired,
    handleFilter: PropTypes.func.isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
